// @flow

import React from 'react';
import { useIntl } from 'react-intl';
import { Heading } from '@riseart/common';
import { Section, Wrapper } from '@riseart/layout';
import { pagination as ENUM_PAGINATION } from 'Enum';
import { useStoreCode } from 'shared_services/redux/hooks/useStoreCode';
import { LayoutDefault } from 'shared_components/layouts/Default';
import { Breadcrumbs } from 'shared_components/common/breadcrumbs/Breadcrumbs';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { ActivityList } from 'shared_components/activity/List';
import { HOCGridPaginated } from 'shared_hocs/common/grid/Paginated';
import FILTER_ACTIVITIES from 'shared_data/queries/activities/filter.graphql';

type Props = { routeConfig: Object };

const ActivityFeedGrid = HOCGridPaginated(ActivityList);

/**
 * ActivityListPage
 *
 * @param {Prop} prop
 */
export default function ActivityListPage({ routeConfig }: Props) {
  const { formatMessage } = useIntl();
  const storeCode = useStoreCode();

  return (
    <LayoutDefault scrollTopOnPathChange>
      <Section padding="none">
        <Wrapper>
          <Breadcrumbs
            generateLDJson={false}
            links={[
              {
                isLink: false,
                name: formatMessage({ id: 'components.breadcrumbs.activityList' }),
                url: UrlAssembler.byRouteKey(routeConfig.key),
              },
            ]}
          />
          <Heading tag="h1" level="1" align="center">
            {formatMessage({ id: 'components.activity.listTitle' })}
          </Heading>
        </Wrapper>
      </Section>
      <Section>
        <Wrapper
          sizes={{
            xs: 'wide',
            sm: 'wide',
            md: 'wide',
            lg: 'narrow',
            xl: 'narrow',
          }}
        >
          <ActivityFeedGrid
            fetchQuery={FILTER_ACTIVITIES}
            variables={{ store: storeCode, items: 10 }}
            ssrQuery
            skipQuery={!storeCode}
            paginationType={ENUM_PAGINATION.type.INFINITE}
          />
        </Wrapper>
      </Section>
    </LayoutDefault>
  );
}
